import '../AboutMumulyaPage/AboutMumulyaPage.css';
import Cover from "../../components/Cover/Cover";
import coverImage from "../../assets/images/mainCoverImage.webp";
import coverImageMobile from "../../assets/images/mainCoverImageMobile.webp";
import aboutMumulyaImageOne from "../../assets/images/aboutMumulyaImageOne.webp";
import aboutMumulyaImageTwo from "../../assets/images/aboutMumulyaImageTwo.webp";
import aboutMumulyaImageThree from "../../assets/images/aboutMumulyaImageThree.webp";

const AboutMumulyaPageRu = () => {
  const isMobile = window.innerWidth <= 1199;
  const coverImageToUse = isMobile ? coverImageMobile : coverImage;
  return (
    <div className='page'>
         <title>О ТМ «Мумуля» — натуральные молочные продукты с любовью</title>
         <meta name="description" content={"Узнайте больше о бренде «Мумуля» — производителе вкусных и полезных молочных продуктов для всей семьи. Молоко, йогурты, творожки, сметана и масло — всё с заботой и любовью, как для своих."}/>
    <Cover text={"“Мумуля” — это всегда вкусно!"} src={coverImageToUse} />
    <section className="about__mumulya-production">
    <div className="about__mumulya-production-wrapper">
      <div className="about__mumulya-production-texts">
        <h1 className="about__mumulya-production-title mont-m">
        Мумуля! Му-му-му!
        </h1>
        <p className="about__mumulya-production-text int-r-21">
        Молоко — это первый продукт, который нужен всем для жизни, роста и здоровья, и ТМ «Мумуля» хорошо это знает.
        </p>
        <p className="about__mumulya-production-text int-r-21">
        Наша Мумуля — с дипломом пищевого института, с идеями повара-кулинара, заботливым сердцем мамы и амбициями блогера-миллионщицы.
        </p>
        <p className="about__mumulya-production-text int-r-21">
        Она знает, когда молоко должно быть теплым, а когда охлажденным, как сделать йогурт густым, творог — нежным, а ряженку — бархатистой.
        </p>
      </div>
      <img
        src={aboutMumulyaImageOne}
        alt="Виробництво Миколаївмолпром"
        className="about__mumulya-production-image"
      />
    </div>
    <div className="about__mumulya-production-wrapper reversed">
      <div className="about__mumulya-production-texts">
        <h3 className="about__mumulya-production-subtitle mont-m">
        Мумуля знает о молоке
        </h3>
        <p className="about__mumulya-production-text int-r-21">
        А главное — Мумуля знает, как накормить всю семью так, чтобы и вкусно, и полезно, и еще немного «на потом» осталось.
        </p>
        <p className="about__mumulya-production-text int-r-21">
        Для детей — натуральное молоко и творог для развития косточек.
        </p>
        <p className="about__mumulya-production-text int-r-21">
        Для подростков — вкусные йогурты и желе.
        </p>
        <p className="about__mumulya-production-text int-r-21">
        Маме — кефир для стройности.
        </p>
        <p className="about__mumulya-production-text int-r-21">
        Отцу — сметану для борща и пельменей.
        </p>
        <p className="about__mumulya-production-text int-r-21">
        Бабушкам и дедушкам — сливочное масло, которое они так любят намазывать на булочку с домашним вареньем. Вкуснятина!
        </p>
        <p className="about__mumulya-production-text int-r-21">
        А что вам нравится? Плавленый сырок? А может, сметанный десерт?
        </p>
      </div>
      <img
        src={aboutMumulyaImageTwo}
        alt="Виробництво Миколаївмолпром"
        className="about__mumulya-production-image two"
      />
    </div>
    <div className="about__mumulya-production-wrapper">
      <div className="about__mumulya-production-texts">
        <h3 className="about__mumulya-production-subtitle mont-m">
        Мумуля — ласковая, как мама
        </h3>
        <p className="about__mumulya-production-text int-r-21">
        ТМ «Мумуля» — это народный бренд, он рядом с нами.
        </p>
        <p className="about__mumulya-production-text int-r-21">
        Молочная коровка Мумуля «прописана» в Южном регионе Украины — на Доманевском маслосырзаводе.
        </p>
        <p className="about__mumulya-production-text int-r-21">
        Но рабочий халат не носит, потому что часто гуляет по душистым лугам, чтобы дать питательное молоко для завода.
        </p>
        <p className="about__mumulya-production-text int-r-21">
        Управляет технологическими процессами прямо с луга, а на заводе бывает вечером — чтобы придумывать рецепты новых сиропов и йогуртов.
        </p>
        <p className="about__mumulya-production-text int-r-21">
        Говорят, если тихо-тихо открыть холодильник — можно услышать нежное «Му-му-му», потому что МУМУЛЯ рядом.
        </p>
        <p className="about__mumulya-production-text int-r-21">
        Мумуля — ласковая, как мама. И не забудьте поблагодарить. Потому что Мумуля — это всегда вкусно!
        </p>
      </div>
      <img
        src={aboutMumulyaImageThree}
        alt="Виробництво Миколаївмолпром"
        className="about__mumulya-production-image three"
      />
    </div>
  </section>
</div>
  )
}

export default AboutMumulyaPageRu